import type { User } from 'API';

export const getUserFullName = (user?: Pick<User, 'firstName' | 'lastName'>) =>
    user ? `${user.firstName} ${user.lastName}` : undefined;
